import type { StaticEntityType } from "@config";
import { CarouselView } from "./carousel.view";
import "../styles/carousel.scss";

interface IProps {
  entity: StaticEntityType;
}

export const CarouselLibrary = ({ entity }: IProps) => {
  return <CarouselView entity={entity} sets={entity.children} />;
};
